module.exports = __webpack_public_path__ + "a2bf17ffbc828b5a6846975aef33373e.png";